import { BaseModelActive, BaseModel, DayOfWeek } from '../../../shared/base/base.models';
import { PointOfSale } from '../points-of-sale/points-of-sale.models';
import { MeanOfDelivery } from '../means-of-delivery/means-of-delivery.models'
import { Time } from '@angular/common';
import { Municipality } from '../municipalities/municipalities.models';

export class DistributionChannel extends BaseModelActive {
    documentNumber?: string;
    validFrom?: Date;
    validTo?: Date;
    pointOfSale?: PointOfSale | string;
    meansOfDelivery?: MeanOfDelivery | string;
    municipality?: Municipality | string;
    status?: DistributionChannelStatus | string;
    dailyCapacities?: DistributionChannelDailyCapacity[] = [];
}

export class DistributionChannelDailyCapacity extends BaseModel {
    dayOfWeek?: DayOfWeek | string;
    timeFrom?: Time;
    timeTo?: Time;
    capacityPerHour?: number;
}

export enum DistributionChannelStatus {
    PREPARATION, ACTIVE, INACTIVE
}